import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XCircleIcon, CakeIcon } from '@heroicons/react/solid'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

const public_url = process.env.PUBLIC_URL + '/'

export const KajubidayModal = ({
  isOpen,
  handleClose,
}: Props) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={handleClose}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          
          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
              <div className="absolute right-4 top-4">
                <XCircleIcon
                  className="h-6 w-6 cursor-pointer"
                  onClick={() => handleClose()}
                />
              </div>
              <div>
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-300">
                  <CakeIcon
                    className="h-6 w-6 text-yellow-200"
                    aria-hidden="true"
                  />
                </div>
                <div className="mt-3 text-center sm:mt-5">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                  Happy potato day to one and all
                  </Dialog.Title>
                  <p className="text-sm text-gray-500">(and year so far of cookle)</p>
                  <br/>
                  <p className="text text-gray-500">
                    🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔<br/>
                    🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔<br/>
                    🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔 🥔 <span className='drop-shadow-lg shadow-black outline outline-2 rounded-2xl outline-offset-2'>🥔</span><br/>
                    Here's to so many more.<br/><br/>
                    <img src={public_url + 'labelled-potatoes.jpg'} className="" alt={public_url + 'labelled-potatoes.jpg'}/>
                  </p>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
